__turbopack_context__.v({
  "article": "-01VGa_article",
  "body": "-01VGa_body",
  "breadcrumbs": "-01VGa_breadcrumbs",
  "byline": "-01VGa_byline",
  "callout": "-01VGa_callout",
  "cta": "-01VGa_cta",
  "ctaActions": "-01VGa_ctaActions",
  "ctaError": "-01VGa_ctaError",
  "description": "-01VGa_description",
  "eyebrow": "-01VGa_eyebrow",
  "faqs": "-01VGa_faqs",
  "figure": "-01VGa_figure",
  "figureImage": "-01VGa_figureImage",
  "hero": "-01VGa_hero",
  "heroImage": "-01VGa_heroImage",
  "page": "-01VGa_page",
  "primaryCta": "-01VGa_primaryCta",
  "resourceCard": "-01VGa_resourceCard",
  "resourceGrid": "-01VGa_resourceGrid",
  "resourceImage": "-01VGa_resourceImage",
  "tableRegion": "-01VGa_tableRegion",
});
